import type { ContextType } from 'preact';
import type { FormVariantContext } from '#hooks/UNSAFE_useFormVariantContext';

type FormVariant = ContextType<typeof FormVariantContext>;

const EMBEDDED_VARIANTS = ['legacyEmbedded', 'embedded'];

const defaultTextAlignForVariant = (variant: FormVariant) =>
  // JET-72775 - Form control alignment in tables
  // When we are in legacy collection components, we want to inherit the text align
  // so we return undefined here and let the consuming components set the styles needed
  // for inheriting. Otherwise, we want to default to textAlign: 'start'.
  variant === 'legacyEmbedded' ? undefined : 'start';

const isEmbeddedVariant = (variant: FormVariant) => variant && EMBEDDED_VARIANTS.includes(variant);

export { defaultTextAlignForVariant, isEmbeddedVariant };
